import { defaultConfig } from 'app/config/environment';

/**
 * Obtiene la configuración del viewer
 * @param {boolean} isEnableNutrient - Indica si el nutrient está habilitado
 * @param {boolean} isEnableNutrientStandalone - Indica si el nutrient standalone está habilitado
 * @param {string} nutrientLicence - La licencia del nutrient
 * @returns {object} La configuración del viewer
 */

export function getViewerConfig({ isEnableNutrient, isEnableNutrientStandalone, nutrientLicence }) {
  const docConfigTemp = {
    toolbar: [
      'TOC_AND_THUMBNAILS',
      'COMMENTS',
      'HOTSPOTS',
      'HAND',
      'SELECT_TEXT',
      'DRAWING',
      'TEXT',
      'SHAPES',
      'ERASER',
      'SEARCH',
      'PRINT',
      'VIEW_CONTROLS',
      'ZOOM_IN',
      'ZOOM_OUT',
    ],
    isReadWithNoCache: true, // Leerá desde files-storage con el parámetro no-cache
    library: 'nutrient',
  };

  if (isEnableNutrient && isEnableNutrientStandalone) {
    docConfigTemp.library = 'nutrient-standalone';
    if (nutrientLicence) {
      try {
        const licence = JSON.parse(nutrientLicence);
        docConfigTemp.licenceKey = licence[window.location.host];
      } catch (e) {
        console.log('e', e);
        docConfigTemp.licenceKey = '';
      }
    } else {
      docConfigTemp.licenceKey = '';
    }
  }

  if (isEnableNutrient && !isEnableNutrientStandalone) {
    docConfigTemp.library = 'nutrient';
    let host = window.location.host.replace('backoffice.', '').replace('publisher.', '').replace('adminescuela.', '');
    if (window.location.host.includes('localhost')) {
      host = new URL(defaultConfig?.BASE_URL_).hostname;
    }
    docConfigTemp.documentEngineUrl = `https://doc-eng.${host}/`;
    docConfigTemp.documentEngineJWTUrl = `https://${host}/doc-eng-service/documents/DOCUMENT_GUID/token`;
  }

  return docConfigTemp;
}
